module.exports = __webpack_public_path__ + "src/assets/img/page5/2d7c943a7711005a2880d0c28ba7fdd1.png";